const mapFunds = funds => {
    return funds.map(fund => {
        let { name, ...restOfFund } = fund;

        switch (fund.code) {
            case 'GEN':
                name = 'General Fund (U.S.)';
                break;

            case 'CANUNR':
                name = 'General Fund (Canada)';
                break;

            case '9062LA':
                name = 'Launch Academy Summer Internship Program';
                break;

            case 'MENTOR':
                name = 'Mentorship Program';
                break;

            case 'SCF':
                name = 'Student Conference Fund (U.S.)';
                break;

            case 'CANSCF':
                name = 'Student Conference Fund (Canada)';
                break;

            default:
                name = fund.name;
        }

        return {
            name,
            ...restOfFund,
        };
    });
};

export default mapFunds;
